<script setup lang="ts">
const { navigationState, toggleMobileDrawer } = useNavigation();
const { t } = useI18n();
</script>

<template>
  <button class="nav-toggle" @click="toggleMobileDrawer">
    <span class="u-visually-hidden">{{ t("layout.navigation.toggle") }}</span>
    <span
      :class="[
        'nav-toggle__icon',
        {
          'nav-toggle__icon--open': navigationState.mobileDrawerOpen,
        },
      ]"
    >
      <span class="nav-toggle__bar" />
      <span class="nav-toggle__bar" />
    </span>
  </button>
</template>

<style scoped lang="scss">
/* stylelint-disable no-descending-specificity */

/* TODO: fix all the specificity issues */
.nav-toggle {
  display: block;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  background: none;
  border: none;

  &:hover {
    .nav-toggle__bar {
      background-color: var(--cm-color-red-hover, hsl(347deg 100% 40%));
    }

    cursor: pointer;
  }

  &__icon {
    position: relative;
    display: block;
    height: 12px;

    &--open .nav-toggle__bar:nth-child(1) {
      top: 6px;
      transform: rotate(45deg);
    }

    &--open .nav-toggle__bar:nth-child(2) {
      top: 6px;
      transform: rotate(-45deg);
    }
  }

  &__bar {
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: var(--cm-color-black, hsl(0deg 0% 0%));
    transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);

    &:nth-child(1) {
      top: 0;
      left: 0;
    }

    &:nth-child(2) {
      bottom: 0;
      left: 0;
    }
  }
}
</style>
